import { TamanhoFraldaGeriatricaEnum } from 'graphql/types.generated'
import { onlyNumbersNonZeroLeft } from 'util/mask'

import AtestadoModel, { CidadaoAtestado } from '../components/model-atestado'
import {
  buildCid10Substring,
  buildCpfCnsSubstring,
  buildDocumentoSubstring,
  buildNomeSubstring,
} from '../utils-atestado'

type SolicitacaoFraldasGeriatricasTextParams = {
  cidadao: CidadaoAtestado
  values?: AtestadoModel
}

const buildTamanhoFraldaSubstring = (tamanhoFralda: TamanhoFraldaGeriatricaEnum | undefined): string =>
  tamanhoFralda || '[Tamanho da fralda]'

const buildUnidadesPorDiaSubstring = (unidadesPorDia: number | undefined): string =>
  unidadesPorDia ? 'unidade'.pluralizeAndConcatValue(unidadesPorDia) : '[Recomendação diária] unidades'

const buildTotalUnidadesSubstring = (unidadesPorDia: number | undefined): string =>
  unidadesPorDia ? `${unidadesPorDia * 30}` : '[Total]'

export const getSolicitacaoFraldasGeriatricasText = ({
  cidadao,
  values,
}: SolicitacaoFraldasGeriatricasTextParams): string => {
  const nome = buildNomeSubstring(cidadao)
  const documento = buildCpfCnsSubstring(cidadao, values?.cpfCns, values?.naoPossui)
  const documentoSubstring = buildDocumentoSubstring(documento)
  const cid10 = buildCid10Substring(values?.cid10)
  const tamanhoFralda = buildTamanhoFraldaSubstring(values?.tamanhoFralda)
  const unidadesPorDia = buildUnidadesPorDiaSubstring(values?.unidadesPorDia)
  const totalUnidades = buildTotalUnidadesSubstring(values?.unidadesPorDia)

  return (
    `Atesto que o(a) Sr.(a) ${nome}${documentoSubstring} ` +
    `encontra-se em acompanhamento de saúde de sua condição clínica${cid10} e, em decorrência disso, ` +
    `faz uso contínuo de fraldas geriátricas, tamanho ${tamanhoFralda}, ` +
    `com recomendação de aproximadamente ${unidadesPorDia} por dia, ` +
    `totalizando ${totalUnidades} unidades por mês.`
  )
}

export const parseUnidadesPorDia = (value: string): number | undefined => {
  const parsed = onlyNumbersNonZeroLeft(value)

  return parsed ? Number(parsed) : undefined
}
